import styled from 'styled-components'

import {
  CardComponent,
  AtlasColor,
  AtlasBodySubtitle,
  AtlasBodyMain,
  Divider,
  AtlasCaption
} from '@justomx/atlas-components'
import { Icon } from '@justomx/atlas-icons'

import type { ProductLocation } from 'types/commons/model'
import { FabButtonAtom } from 'components/atoms/FabButton.atom'
import { FlexRowAtom } from 'components/atoms/FlexRow.atom'
import { FlexSpaceBetweenAtom } from 'components/atoms/FlexSpaceBetween.atom'
import { FlexColumnAtom } from 'components/atoms/FlexColumn.atom'
import { ProductZoneMolecule } from './ProductZone.molecule'

interface FooterLine {
  label: string
  value: string
}

interface DataCardProps {
  imageUrl: string
  title: string
  subtitle: string
  footerLines?: FooterLine[]
  showErrorState?: boolean
  actionIcon?: string
  action?: () => void
  zone?: string
  locations?: ProductLocation[]
  disableCopy?: boolean
  showLocations?: boolean
}

const ProductImage = styled.img`
  width: 70px;
  height: 70px;
  border-radius: 8px;
`

const ProductDetailContainer = styled(FlexColumnAtom)`
  justify-content: center;
`

const NoLocationsTag = styled(FlexRowAtom)`
  background-color: ${AtlasColor.Error};
  color: ${AtlasColor.TextTitle};
  padding: 4px 8px;
  border-radius: 4px;
  display: inline-flex;
  width: fit-content;
  gap: 4px;
  align-items: center;
`

export const DataCardMolecule = (props: DataCardProps) => {
  const {
    imageUrl,
    title,
    subtitle,
    footerLines,
    showErrorState,
    actionIcon,
    zone,
    locations,
    disableCopy,
    showLocations = true,
    action
  } = props

  return (
    <CardComponent
      style={{
        border: `1px solid ${
          showErrorState ? AtlasColor.Error : AtlasColor.PrimarySurface
        }`,
        userSelect: disableCopy ? 'none' : undefined
      }}
    >
      <FlexSpaceBetweenAtom $gap={10}>
        <FlexRowAtom $gap={16}>
          <ProductImage src={imageUrl} alt="product" />
          <ProductDetailContainer $gap={16}>
            <AtlasBodySubtitle>{title}</AtlasBodySubtitle>
            <AtlasCaption>{subtitle}</AtlasCaption>
            {(!locations || (locations && locations.length === 0)) && (
              <NoLocationsTag>
                <Icon name="ic_information" size={16} />
                <AtlasCaption>Sin ubicación</AtlasCaption>
              </NoLocationsTag>
            )}
          </ProductDetailContainer>
        </FlexRowAtom>

        {action && actionIcon && (
          <FabButtonAtom
            type="button"
            $variant="secondary"
            $alignSelf="self-start"
            onClick={action}
          >
            <Icon name={actionIcon} color={AtlasColor.Primary} size={24} />
          </FabButtonAtom>
        )}
      </FlexSpaceBetweenAtom>

      {!!footerLines?.length && <Divider />}

      {footerLines?.map((line, index) => (
        <FlexSpaceBetweenAtom key={index}>
          <AtlasBodyMain>{line.label}</AtlasBodyMain>
          <AtlasBodyMain>{line.value}</AtlasBodyMain>
        </FlexSpaceBetweenAtom>
      ))}
      {showLocations && locations && locations.length > 0 && (
        <ProductZoneMolecule locations={locations} zone={zone} />
      )}
    </CardComponent>
  )
}
